'use client';
import CountUp from "react-countup";
import {
    Accordion,
    AccordionItem,
    AccordionBody,
    AccordionHeader,
    AccordionButton,
    AccordionCollapse,
    useAccordionButton,
    Alert,
    AlertHeading,
    AlertLink,
    Badge,
    Breadcrumb,
    BreadcrumbItem,
    ButtonGroup,
    ButtonToolbar,
    Button,
    ToggleButtonGroup,
    ToggleButton,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    CardImg,
    CardImgOverlay,
    CardLink,
    CardSubtitle,
    CardText,
    CardTitle,
    CardGroup,
    Carousel,
    CarouselItem,
    CarouselCaption,
    CloseButton,
    DropdownButton,
    SplitButton,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    DropdownHeader,
    DropdownDivider,
    Figure,
    FigureImage,
    FigureCaption,
    Image,
    ListGroup,
    ListGroupItem,
    Modal,
    ModalDialog,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Navbar,
    NavbarBrand,
    NavbarToggle,
    NavbarCollapse,
    Nav,
    NavItem,
    NavLink,
    NavDropdown,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasTitle,
    OffcanvasBody,
    Overlay,
    OverlayTrigger,
    Tooltip,
    Popover,
    PopoverBody,
    PopoverHeader,
    Pagination,
    PageItem,
    Placeholder,
    PlaceholderButton,
    ProgressBar,
    Spinner,
    Table,
    Tabs,
    Tab,
    TabContainer,
    TabContent,
    TabPane,
    Toast,
    ToastHeader,
    ToastBody,
    ToastContainer,
} from "react-bootstrap";
import Slider, { SliderItem } from "@/element/common/Slider";
import ShowGoToTop, { goToTop, MoveNewsSidebar, MoveFooterSubscribeForm, MoveContactUsForm, MoveJobApplicationForm } from "./scrolltotop";
// import OpenSidemenu from "./openSidemenu";
import { motion } from "framer-motion";
import Link from "next/link";
import VideoModal from "./videoModal";
import { CircularProgressBar } from "react-percentage-bar";
import "react-percentage-bar/dist/index.css";
import ImageModal from "./imageModal";
import ParallaxRotateBox from "./parallaxRotateBox";
import CountUpOnlyOnce from "./countUpOnlyOnce";
import Tforms from "../typo3/form_formframework";
import ZoomOutOnScroll from "./zoomOutOnScroll";
import SidemenuContentWrapper from "./sidemenuContentWrapper";
import PortfolioLoadMore from "./portfolioLoadMore";
import InstagramFeed from "./InstagramFeed";
import ServiceDetail from "./serviceDetail";
import BackUrl from "./backUrl";
import NewsSocialShare from "./NewsSocialShare";
import ProjectNavigation from "./ProjectNavigation";

const MotionDiv = motion.create("div");
const MotionSpan = motion.create("span");
const MotionA = motion.create("a");
const MotionH1 = motion.create("h1");
const MotionH2 = motion.create("h2");
const MotionH3 = motion.create("h3");
const MotionH4 = motion.create("h4");
const MotionH5 = motion.create("h5");
const MotionH6 = motion.create("h6");
const MotionP = motion.create("p");
const MotionSVG = motion.create("svg");
const MotionSVGPath = motion.create("path");
const MotionLink = motion.create(Link);
const PaginationItem = Pagination.Item;

export {
    Accordion,
    AccordionItem,
    AccordionBody,
    AccordionHeader,
    AccordionButton,
    AccordionCollapse,
    useAccordionButton,
    Alert,
    AlertHeading,
    AlertLink,
    Badge,
    Breadcrumb,
    BreadcrumbItem,
    ButtonGroup,
    ButtonToolbar,
    Button,
    ToggleButtonGroup,
    ToggleButton,
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    CardImg,
    CardImgOverlay,
    CardLink,
    CardSubtitle,
    CardText,
    CardTitle,
    CardGroup,
    Carousel,
    CarouselItem,
    CarouselCaption,
    CloseButton,
    DropdownButton,
    SplitButton,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    DropdownHeader,
    DropdownDivider,
    Figure,
    FigureImage,
    FigureCaption,
    Image,
    ListGroup,
    ListGroupItem,
    Modal,
    ModalDialog,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Navbar,
    NavbarBrand,
    NavbarToggle,
    NavbarCollapse,
    Nav,
    NavItem,
    NavLink,
    NavDropdown,
    Offcanvas,
    OffcanvasHeader,
    OffcanvasTitle,
    OffcanvasBody,
    Overlay,
    OverlayTrigger,
    Tooltip,
    Popover,
    PopoverBody,
    PopoverHeader,
    Pagination,
    PageItem,
    Placeholder,
    PlaceholderButton,
    ProgressBar,
    Spinner,
    Table,
    Tabs,
    Tab,
    TabContainer,
    TabContent,
    TabPane,
    Toast,
    ToastHeader,
    ToastBody,
    ToastContainer,


    CountUp,
    CircularProgressBar,

    MotionDiv,
    MotionSpan,
    MotionA,
    MotionH1,
    MotionH2,
    MotionH3,
    MotionH4,
    MotionH5,
    MotionH6,
    MotionP,
    MotionLink,
    MotionSVG,
    MotionSVGPath,

    Slider,
    SliderItem,
    goToTop,
    VideoModal,
    ImageModal,
    ShowGoToTop,
    PaginationItem,

    ParallaxRotateBox,
    ZoomOutOnScroll,
    CountUpOnlyOnce,
    Tforms,
    SidemenuContentWrapper,
    ProjectNavigation,
    PortfolioLoadMore,
    InstagramFeed,
    BackUrl,
    MoveNewsSidebar,
    MoveFooterSubscribeForm,
    MoveContactUsForm,
    MoveJobApplicationForm,
    NewsSocialShare,
    ServiceDetail,
    // OpenSidemenu
};


